import { render, staticRenderFns } from "./EditingSubFrame.vue?vue&type=template&id=973868c2&"
import script from "./EditingSubFrame.vue?vue&type=script&lang=js&"
export * from "./EditingSubFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports